exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popperTipBox {\n  max-width: 37.5rem;\n  max-height: 31.25rem;\n  overflow-y: auto;\n}\n.popperTipBox::-webkit-scrollbar {\n  width: 0.375rem;\n  height: 0.375rem;\n}", ""]);

// exports
